<template>
  <div class="ui-block">    
    <div class="about-group-header" @click="changeDisplay" v-if="checkWidth">
      <span>About me</span>
      <md-icon v-if="customClass === 'displayNone'">arrow_right </md-icon>
      <md-icon v-else>arrow_drop_down</md-icon>
      <p v-show="customClass === 'displayNone'" v-if="checkWidth">{{aboutDescription()}}</p>     
    </div>
    <router-link
      class="settings-button"
      :to="{ name: 'ProfileSettings' }"
      data-cy="profileSettingsBtn"
      v-if="this.about.id === this.loggedUser.id && showSettingIcon"
    >
      <span class="material-icons-outlined"> settings </span>
    </router-link>
    <div class="ui-block-content" :class="customClass">
    
      <ul class="widget w-personal-info item-block">
        
        <li>
          <span class="title" v-if="about.id === loggedUser.id">About me</span>
          <span class="title" v-else>About {{ about.firstName }}</span>
          <span class="text">{{ aboutDescription() }}</span>
        </li>
        <li>
          <span class="title">Location</span>
          <span class="text">
            <span v-if="city">
                {{`${city}`}}
            </span>
            <span v-if="state">
                {{`, ${state}`}}
            </span>
            <span v-if="country">
                {{`, ${country}`}}
            </span>
          </span>
        </li>
        <li>
          <span class="title">ZIP code</span>
          <span class="text">{{ about.zip }}</span>
        </li>
        <li>
          <span class="title">Since</span>
          <span class="text">{{
            new Date(about.createdAt).toLocaleDateString("en-US")
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import UserHelper from "../../mixins/UserHelper.vue";
import * as  axios from'axios';
export default {
  name: "ProfileAboutMe",
  props: ["about"],
  mixins: [UserHelper],
  data() {
    return {
      customClass: "displayNone",
      screenSize: window.innerWidth,
      showSettingIcon: true,
      state: undefined,
      city: undefined,
      country: undefined
    };
  },
  async created() {
    const url = 'https://app.zipcodebase.com/api/v1/search';
    const parametros = {
      apikey: '11ae8520-0f06-11ee-b81e-9ba872d04347',
      codes: this.about.zip,
      country: 'us'
    };

    const resposta = await axios.get(url, { params: parametros });
    this.city = resposta.data.results[this.about.zip][0].city;
    this.state = resposta.data.results[this.about.zip][0].state;
    this.country = resposta.data.results[this.about.zip][0].country_code;
    if(this.about.id === this.loggedUser.id){
      this.showSettingIcon = window.innerWidth > 1024;
    } 
  },
  mounted() {
    $(".privacy-tooltip").tooltip();
    window.addEventListener("resize", () => {
      this.sizeOfScreen();
      this.handleResize();
    });
  },
  computed: {
    checkWidth() {
      return this.screenSize <= 1023;
    },
  },
  methods: {
    aboutDescription() {
      if (!this.about) return "";
      if (this.about.length >= 150 && window.innerWidth <= 768)
        return `${this.about.slice(0, 149)} ...`;
      return this.about.description;
    },
    changeDisplay() {
      this.customClass =
        this.customClass === "displayNone" ? "displayShow" : "displayNone";
    },
    sizeOfScreen() {
      this.screenSize = window.innerWidth;
    },
    handleResize() {
      if(this.about.id === this.loggedUser.id){
        this.showSettingIcon = window.innerWidth > 1024;
      } 
    },
  },
};
</script>
<style scoped>
.about-group-header {
  font-size: 16px;
  display: block;
  justify-content: space-between;
  padding: 10px 23px 0px;
  font-weight: bold;
  color: #3d3d3d;
}

.about-group-header i {
  margin: unset;
  cursor: pointer;
}

.about-group-header p {
  max-width: 52em;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.8em;
  font-weight: normal;
  color: #888da8;
  margin-top: 0.4em;
  font-weight: normal;
  margin-bottom: 6px
}


@media screen and (max-width: 1023px) {
  .md-icon {
    float: right;
  }
  .displayNone {
    display: none;
  }
  .displayShow {
    padding-top: unset;
    display: block;
  }
}

.settings-button {
  width: 2em;
  height: 2em;
  position: absolute;
  right: 1em;
  align-content: left;
  margin-top: 1em
}

.settings-button .material-icons-outlined {
  color: gray !important;
}
</style>
